import { Text } from '@chakra-ui/react'
import { DateTime } from 'luxon'

import { toHumanReadableString } from '@/utils/time'

import SeriesQ from '@/queries/SeriesQ'
import SeriesReservationQ from '@/queries/SeriesReservationQ'
import { useUser } from '@/client/context/user'
import { useServerNow } from '@/client/hooks'
import type { Query } from '@/client/query'
import * as url from '@/client/services/url'

import useSATBootcampLearnerOnboardingState from '@/components/SATBootcamp/hooks/useSATBootcampLearnerOnboardingState/useSATBootcampLearnerOnboardingState'
import ShwLink from '@/components/ShwLink'
import Alert from '@/components/UI/Alert'

export default function SeriesConsentReminderBanner({ series }: { series: Query }) {
  const user = useUser()
  const now = useServerNow()

  const { parentConsentCompletedAt: satLearnerParentConsentCompletedAt } =
    useSATBootcampLearnerOnboardingState()

  const lastReservationExpiredAt = series<string>`MAX(${
    SeriesReservationQ.expired_at
  }) ${SeriesQ.getActiveSelfReservations(user.id)}`

  const isUserSelfReserved = series(SeriesQ.isUserSelfReserved(user.id)) ?? false

  const linkParentConsent = url.getRequestParentConsentUrl()

  let expirationText = ''
  if (lastReservationExpiredAt != null) {
    expirationText = `Your spot expires ${toHumanReadableString(
      DateTime.fromISO(`${lastReservationExpiredAt}`).diff(now)
    )}.`
  }
  return isUserSelfReserved ? (
    <Alert variant="warning">
      <Text>
        {expirationText}{' '}
        {satLearnerParentConsentCompletedAt == null ? (
          <>
            Please remind your parent to{' '}
            <ShwLink href={linkParentConsent}>complete the consent form</ShwLink>!
          </>
        ) : null}
      </Text>
    </Alert>
  ) : null
}
